
import React from "react";
import { Trash2 } from "lucide-react";
import { UserType } from "@/lib/supabase/types";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface SelectedUserCardProps {
  user: UserType;
  onRemove: () => void;
}

const SelectedUserCard: React.FC<SelectedUserCardProps> = ({ user, onRemove }) => {
  return (
    <div className="flex items-center gap-2 mt-2">
      <Avatar className="h-8 w-8">
        <AvatarFallback>
          {user.firstName.charAt(0)}{user.lastName.charAt(0)}
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col">
        <span className="font-medium">{user.firstName} {user.lastName}</span>
        <span className="text-xs text-muted-foreground">{user.email}</span>
      </div>
      <Button 
        variant="ghost" 
        size="sm" 
        className="ml-auto"
        onClick={onRemove}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default SelectedUserCard;
